module.exports = __webpack_public_path__ + "img/chess-queen-piece.00eee269.svg";